export default __webpack_public_path__ + "static/logo-text-white-411e853f47862499b55698d733f28a83.png";